import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AlertService, Constants } from 'src/app/shared';

@Component({
  selector: 'app-lang-change',
  templateUrl: './lang-change.component.html',
  styleUrls: ['./lang-change.component.scss']
})
export class LangChangeComponent implements OnInit {
  langChange = false;
  lang: string;
  langData: any;
  constructor(
    public translate: TranslateService,
    private alertService: AlertService
  ) {
    this.translate.stream('home').subscribe((subStream: any) => {
      this.langData = subStream;
    });
  }

  ngOnInit() {
    this.lang = localStorage.getItem('lang') || 'en';
  }

  changeLang(lang) {
    localStorage.setItem('lang', lang);
    console.log(lang);
    this.translate.use(lang);
    this.langChange = Constants.BOOLEAN_TRUE;
    this.alertService.showSuccess(this.langData.alert);
    window.location.reload();
  }
}
